import React from 'react';
import { fontSans, pageGutter, warmHeaderBg } from './requestChangesStyles';

const WELCOME_COPY =
  "Review your selections below. If you'd like to make an adjustment, choose Request Changes to update quantities, add products, or revise project details. When everything looks right, choose Accept Proposal to begin confirmation.";

export default function ProposalWelcomePanel({ onDismiss, onStartReviewing }) {
  return (
    <div
      className="no-print proposal-welcome-panel"
      role="region"
      aria-label="Welcome to Your Project with Mayker"
      style={{
        width: '100%',
        boxSizing: 'border-box',
        backgroundColor: warmHeaderBg,
        position: 'relative'
      }}
    >
      <style>{`
        .proposal-welcome-inner {
          width: 100%;
          box-sizing: border-box;
          margin: 0 auto;
          max-width: 620px;
          padding: 28px 24px 30px;
          text-align: center;
        }
        .proposal-welcome-dismiss {
          position: absolute;
          top: 12px;
          right: ${pageGutter}px;
        }
        .proposal-welcome-start {
          text-decoration: underline;
          text-underline-offset: 4px;
        }
        .proposal-welcome-dismiss:focus-visible,
        .proposal-welcome-start:focus-visible {
          outline: 2px solid #2C2C2C;
          outline-offset: 3px;
        }
        @media screen and (min-width: 769px) and (max-width: 1024px) {
          .proposal-welcome-dismiss {
            right: 24px !important;
          }
        }
        @media screen and (max-width: 768px) {
          .proposal-welcome-inner {
            padding: 22px 20px 24px !important;
            max-width: 100% !important;
          }
          .proposal-welcome-title {
            font-size: 17px !important;
          }
          .proposal-welcome-dismiss {
            top: 10px !important;
            right: 12px !important;
          }
        }
      `}</style>
      <button
        type="button"
        className="proposal-welcome-dismiss"
        onClick={onDismiss}
        aria-label="Dismiss welcome"
        style={{
          width: 28,
          height: 28,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'none',
          border: 'none',
          padding: 0,
          color: '#8a8378',
          fontSize: 20,
          lineHeight: 1,
          cursor: 'pointer',
          fontFamily: fontSans
        }}
      >
        ×
      </button>
      <div className="proposal-welcome-inner">
        <div
          className="proposal-welcome-title"
          style={{
            fontFamily: fontSans,
            fontSize: 18,
            fontWeight: 500,
            color: '#2C2C2C',
            letterSpacing: '0.01em',
            textTransform: 'none',
            lineHeight: 1.3
          }}
        >
          Welcome to Your Project with Mayker
        </div>
        <p
          className="proposal-welcome-copy"
          style={{
            margin: '12px auto 0',
            fontFamily: fontSans,
            fontSize: 14,
            lineHeight: 1.6,
            color: '#6b645c',
            maxWidth: 600
          }}
        >
          {WELCOME_COPY}
        </p>
        <button
          type="button"
          className="proposal-welcome-start"
          onClick={onStartReviewing}
          style={{
            marginTop: 16,
            background: 'none',
            border: 'none',
            padding: 0,
            fontFamily: fontSans,
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: '#2C2C2C',
            cursor: 'pointer',
            lineHeight: 1.2
          }}
        >
          Start Reviewing ↓
        </button>
      </div>
    </div>
  );
}
